export enum ElearningPublishAction {
  CREATE = 'create',
  UPDATE = 'update',
}

export type ElearningPublishActionType =
  | ElearningPublishAction.CREATE
  | ElearningPublishAction.UPDATE;

export enum ElearningPublishTarget {
  DRAFT = 'draft',
  REVIEW = 'review',
  LIVE = 'live',
  SCORM = 'scorm',
  MULTI_REGION = 'multi-region',
}

export enum ElearningPublishChannel {
  Generic = 0, // Elearning or LMS
  CourseLibrary = 1,
  VideoLibrary = 2,
  SCORM = 3,
  BREATHE = 4,
}

export type ElearningPublishTargetType =
  | ElearningPublishTarget.REVIEW
  | ElearningPublishTarget.LIVE
  | ElearningPublishTarget.SCORM
  | ElearningPublishTarget.MULTI_REGION;
